import AssignmentActions from './actions';

const INITIAL_STATE = {
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  onSubmit:false,
  data:{},
  errorInternal:false,
  helperFull:null
};

function AssignmentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AssignmentActions.BEFORE_ASSIGN:
      return { ...state,isError: false, isProcessing: true,onSubmit:true};
    case AssignmentActions.AFTER_ASSIGN:
      return { ...state, isProcessing: false,onSubmit:false,data:action.payload};
      case AssignmentActions.BEFORE_REVOKE:
        return { ...state,isError: false, isProcessing: true,onSubmit:true};
      case AssignmentActions.AFTER_REVOKE:
        return { ...state, isProcessing: false,onSubmit:false,data:action.payload};
    case AssignmentActions.RESET_LIST:
      return { ...state, isProcessing: false,data:{}, form:INITIAL_STATE.form,isNewRecord:true};
    case AssignmentActions.NEW_DATA:
      return { ...state, isProcessing: false,data:{}, form:INITIAL_STATE.form,isNewRecord:true};
    case AssignmentActions.UPDATE_DATA:
      return { ...state, isProcessing: false, data:{},isNewRecord:false};
    case AssignmentActions.VIEW_DATA:
      return { ...state, isProcessing: false, data:action.payload,isNewRecord:false};
    case AssignmentActions.RESET_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form};
    case AssignmentActions.DELETE_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form};
    case AssignmentActions.ON_SUBMIT:
      return { ...state, onSubmit:true};
    case AssignmentActions.SHOW_DATA:
      return { ...state,  isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case AssignmentActions.SUCCESS_DATA:
      return { ...state, isError: false,form:INITIAL_STATE.form , onSubmit:false};
    case AssignmentActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false,isSuccess:false};
    case AssignmentActions.GET_HELPER:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,helperFull:action.payload};  
    case AssignmentActions.ERROR_DATA:
      return { ...state,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case AssignmentActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
     
    default:
      return state;
    }
}


export default AssignmentReducer;
